import { Link } from 'react-router-dom'
import { useAuth } from '../../lib/auth'
import { useTours } from '../../lib/tours'
import Icon from '../../components/Icon'
import MobileHeader, { MobileScreen } from '../../components/mobile/MobileHeader'
import Empty from '../../components/Empty'
import DayItinerary from './DayItinerary'

/**
 * The itinerary tab.
 *
 * A day at a time, picked from the horizontal strip — the way a day sheet is
 * actually read on the road. The whole-tour scroll is for planning; this is
 * for the morning of.
 *
 * It follows the tour you were last looking at, falling back to whichever tour
 * is running now.
 */
export default function MobileItinerary() {
  const { uid } = useAuth()
  const { tours, loading } = useTours(uid)

  const now = new Date()
  const active =
    tours.find((tour) => tour.startDate.toDate() <= now && tour.endDate.toDate() >= now) ??
    [...tours].sort(
      (a, b) =>
        Math.abs(a.startDate.toMillis() - now.getTime()) -
        Math.abs(b.startDate.toMillis() - now.getTime()),
    )[0]

  return (
    <>
      <MobileHeader title="Itinerary" back={false} />
      <MobileScreen>
        {loading && !active && <p className="t-caption">Loading…</p>}

        {!loading && !active && (
          <Empty
            title="No tour selected"
            message="Pick a tour and its schedule shows up here."
            action={{ label: 'Go to Tours', to: '/tours' }}
          />
        )}

        {active && (
          <>
            <Link to={`/tours/${active.id}`} className="row t-caption" style={{ gap: 6 }}>
              <span className="truncate">{active.tourName}</span>
              <Icon name="chevronRight" size={13} style={{ color: 'var(--text-tertiary)' }} />
            </Link>
            <DayItinerary
              tour={active}
              emptyAction={{ label: 'Open the tour', onClick: () => {} }}
            />
          </>
        )}
      </MobileScreen>
    </>
  )
}

